import type { CartNotification } from 'libs/common-node/src';
import { useLocalStorage } from './index';
import { CART_NOTIFICATIONS_STORAGE_KEY } from '@libs/core/constants';

const useCartNotifications = () => {
    const [notifications, setNotifications] = useLocalStorage<CartNotification[]>(CART_NOTIFICATIONS_STORAGE_KEY);

    return { notifications, setNotifications };
};

export { useCartNotifications };
